import { RequestForm } from '@/components/requests/RequestForm';
import { RecentRequestsList } from '@/components/requests/RecentRequestsList';
import '@/styles/requests.css';

export function MyRequestsRoute() {
  return (
    <div className="req-page">
      <RequestForm />
      <RecentRequestsList />
    </div>
  );
}
